module.exports = __webpack_public_path__ + "static/assets/4a3e1c364658c715fe01969e00551112.gif";